export const FLAG_GETTING_PRINT_TEMPLATE_TYPES =
  'FLAG_GETTING_PRINT_TEMPLATE_TYPES';
export const GET_PRINT_TEMPLATE_TYPES = 'GET_PRINT_TEMPLATE_TYPES';
export const CLEAR_PRINT_TEMPLATE_TYPES = 'CLEAR_PRINT_TEMPLATE_TYPES';
